/** Return the same route permission requirements for navigation and permission refresh. */
export function requiredRoutePermissions(route) {
  const meta = route.meta || {}
  if (meta.permissionByQuery) {
    const mode = route.query?.mode === 'monitor' ? 'monitor' : 'gis'
    return [meta.permissionByQuery[mode]]
  }
  if (meta.permission) return [meta.permission]
  return meta.anyPermissions || []
}

/**
 * Refresh permissions after an API rejects page access, then reassess the active route.
 * Requests from a previous route cannot redirect the page the user has since opened.
 */
export function createPagePermissionRecovery({ router, store, getToken, isManager, notify }) {
  let pending = null

  return function recover(sourceRoute = router.currentRoute) {
    const route = router.currentRoute
    const token = getToken()
    const meta = route.meta || {}
    if (sourceRoute !== route || !token || isManager() || meta.public || meta.selfService) {
      return Promise.resolve()
    }
    if (pending?.route === route) return pending.promise

    // Several widgets can fail together; share the permission refresh and notify once per route.
    const refresh = pending?.refresh || Promise.resolve().then(() => store.dispatch('permission/refresh'))
    const isCurrent = () => router.currentRoute === route && getToken() === token
    const promise = refresh.then(async () => {
      if (!isCurrent() || isManager()) return
      if (!meta.managerOnly && store.getters['permission/hasAny'](requiredRoutePermissions(route))) {
        notify.warn('errors.pageSectionForbidden')
        return
      }
      notify.warn('errors.pagePermissionChanged')
      if (route.path !== '/platOverview') await router.replace({ path: '/platOverview' })
    }).catch(() => {
      if (isCurrent()) notify.error('errors.pagePermissionRefreshFailed')
    }).finally(() => {
      if (pending?.promise === promise) pending = null
    })
    pending = { route, refresh, promise }
    return promise
  }
}
